module.exports = __webpack_public_path__ + "static/img/newblack.7575ca5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/newblack.png
// module id = v738
// module chunks = 44